/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import type { Service } from '@ahm/api-wrappers-core';

/**
 * Returns error message and title for a truck service, considering ban hours and estimate errors.
 */
export function getTruckServiceErrorMessage(
  service: Service | null | undefined,
  isServiceRestrictedByBan: boolean,
  estimateError?: { title?: string; description?: string }
): { title: string; description: string } | null {
  if (!service) return null;

  const timeRanges =
    service?.truck_ban?.ban_hours
      ?.map((range) => `${range.from}:00-${range.to}:00`)
      .join(' và ') ?? '';

  const errorMessage = isServiceRestrictedByBan
    ? timeRanges
      ? `Giờ cấm tải ${timeRanges}`
      : 'Cấm tải'
    : (estimateError?.description ?? '');

  if (!errorMessage) return null;

  return {
    title: isServiceRestrictedByBan
      ? 'Dịch vụ bị hạn chế'
      : estimateError?.title || '',
    description: errorMessage,
  };
}
